import { Stroke, Style } from "ol/style";
import { CONTROLLED_ACCESS_HIGHWAY_TYPES } from "./supportedHighwayTypes";
import {
  getNodeStyleNormal,
  getNodeStyleClick,
  getNodeStyleHover,
} from "./node";

export function getControlledAccessStyleNormal(feature) {
  return getControlledAccessColorStyle(feature).concat(
    getNodeStyleNormal(feature),
  );
}
export function getControlledAccessStyleClick(feature) {
  return getControlledAccessColorStyle(feature, true, false).concat(
    getNodeStyleClick(feature),
  );
}
export function getControlledAccessStyleHover(feature) {
  return getControlledAccessColorStyle(feature, false, true).concat(
    getNodeStyleHover(feature),
  );
}
function getControlledAccessColorStyle(feature, click, hover) {
  let color, width;
  const controlledAccess = findValueByKeyEndingWith(
    feature.getProperties(),
    "controlled_access",
  );
  const highway = findValueByKeyEndingWith(feature.getProperties(), "highway");
  if (highway === undefined) {
    color = "black";
    width = 1;
  } else if (!CONTROLLED_ACCESS_HIGHWAY_TYPES.includes(highway)) {
    color = "grey";
    width = 1;
  } else if (controlledAccess === "yes") {
    color = "#E5C95F"; // yellow
    width = 9;
  } else if (controlledAccess === "entrance_exit") {
    color = "#41A67E"; // green
    width = 9;
  } else if (controlledAccess === "connection") {
    color = "#05339C"; // blue
    width = 9;
  } else {
    color = "#abdbe3"; // light blue
    width = 1;
  }
  if (click) {
    return [
      new Style({
        stroke: new Stroke({
          color: color,
          width: width * 3,
        }),
      }),
      new Style({
        stroke: new Stroke({
          color: "#eab676", // orange
          width: width * 2,
        }),
      }),
    ];
  }
  if (hover) {
    return [
      new Style({
        stroke: new Stroke({
          color: "white",
          width: width * 4,
        }),
      }),
      new Style({
        stroke: new Stroke({
          color: color,
          width: width * 2,
        }),
      }),
    ];
  }
  return [
    new Style({
      stroke: new Stroke({
        color: color,
        width: width,
      }),
    }),
  ];
}
function findValueByKeyEndingWith(obj, suffix) {
  const key = Object.keys(obj).find((key) => key.endsWith(suffix));
  return obj[key];
}
